var map = {
	"./artichoke-hearts-in-olive-oil.webp": 9859,
	"./cauliflower-salad-with-pomegranate.webp": 4480,
	"./italian-pesto-zoodle-salad.webp": 4661,
	"./menemen.webp": 6102,
	"./romano-beans-in-olive-oil.webp": 5495,
	"./strawberry-mint-salad.webp": 2719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4619;